import clsx from "clsx";
import { colors } from "../../colors";
import { PlusIcon } from "../../icons/plus";
import Button from "../../molecules/button";
import { Spinner } from "../../molecules/spinner";
import { ConfirmModalProps } from "./dto";
import { useEffect } from "react";
import { createPortal } from "react-dom";

export function ConfirmModal(props: ConfirmModalProps) {
  useEffect(() => {
    const handleEscKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        props.onClose();
      }
    };

    document.addEventListener('keydown', handleEscKeyPress);

    return () => {
      document.removeEventListener('keydown', handleEscKeyPress);
    };
  }, [props]);

  return createPortal(
    <div
      onClick={() => props.onClose()}
      className={clsx(
        "transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]",
        {
          block: props.visible,
          hidden: !props.visible,
        }
      )}
    >
      {props.loading ? (
        <Spinner />
      ) : (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className="transition-all flex flex-col items-center relative bg-white rounded-[12px] opacity-100 shadow-sm min-w-[400px]"
        >
          <div
            onClick={() => props.onClose()}
            className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
          >
            <PlusIcon color={colors.brandPrimary[600]} size={16} />
          </div>
          <div className="p-6 text-heading-xs font-semibold text-center">
            {props.title}
          </div>
          <div className="px-6 py-8 flex h-full flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
            <span className="text-text-md font-normal text-neutral-600">
              {props.label}
            </span>
            <div className="w-full flex flex-1 gap-3">
              <div className="w-1/2">
                <Button
                  fullWidth
                  size={"sm"}
                  iconPosition={"off"}
                  variant={"outline"}
                  color={"gray"}
                  label="Annulla"
                  onClick={() => props.onClose()}
                />
              </div>
              <div className="w-1/2">
                <Button
                  fullWidth
                  size={"sm"}
                  iconPosition={"off"}
                  variant={"solid"}
                  color={"blue"}
                  label="Conferma"
                  onClick={() => props.confirmAction()}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>,
    document.body
  );
}
